<template>
    <div class="certificateValidation">
         <van-nav-bar
            title="证书验证"
        />
        <div class="box">
            <h1 class="title">{{info.businessName}}证书查询结果</h1>
            <img :src="info.url" class="img" alt="">
        </div>
        
    </div>
</template>
<script>
export default {
    name:'certificateValidation',
    data(){
        return {
            info:{}
        }   
    },
    created(){
        this.findById()
    },
    methods:{
        findById(){
            const params = {
                id:this.$route.query.id
            }
            this.$api.certificate.findById({ params }).then(res => {
                this.info = res.data
            })
        },
    }
}
</script>
<style lang="stylus">
@import '../asset/css/certificate.styl'
</style>
